import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from "@/context/UserContext";
import { InnovationProvider } from "@/context/InnovationContext";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute, AreaRoute, AdminRoute, OnboardedGate } from "@/components/auth/RouteGuards";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CommandCentre from "@/pages/CommandCentre";
import OfficeTeam from "@/pages/OfficeTeam";
import ProductContent from "@/pages/ProductContent";
import ModuleDetail from "@/pages/ModuleDetail";
import WeeklyReviewPrint from "@/pages/WeeklyReviewPrint";
import LaunchTracker from "@/pages/LaunchTracker";
import MarketingGrowth from "@/pages/MarketingGrowth";
import InvestorPipeline from "@/pages/InvestorPipeline";
import InvestorDetail from "@/pages/InvestorDetail";
import FinanceRunway from "@/pages/FinanceRunway";
import DecisionsRisks from "@/pages/DecisionsRisks";
import Links from "@/pages/Links";
import AdminUsers from "@/pages/AdminUsers";
import AuditLog from "@/pages/AuditLog";
import RecycleBin from "@/pages/RecycleBin";
import SystemSettings from "@/pages/SystemSettings";

function App() {
  return (
    <div className="App">
      <UserProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/weekly-review/:id/print"
              element={
                <ProtectedRoute>
                  <WeeklyReviewPrint />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <OnboardedGate>
                    <InnovationProvider>
                      <AppShell />
                    </InnovationProvider>
                  </OnboardedGate>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<CommandCentre />} />
              <Route path="/office" element={<OfficeTeam />} />
              <Route path="/product" element={<ProductContent />} />
              <Route path="/product/module/:moduleId" element={<ModuleDetail />} />
              <Route path="/launch" element={<LaunchTracker />} />
              <Route path="/marketing" element={<MarketingGrowth />} />
              <Route
                path="/investors"
                element={<AreaRoute area="investor_access"><InvestorPipeline /></AreaRoute>}
              />
              <Route
                path="/investors/:investorId"
                element={<AreaRoute area="investor_access"><InvestorDetail /></AreaRoute>}
              />
              <Route
                path="/finance"
                element={<AreaRoute area="finance_access"><FinanceRunway /></AreaRoute>}
              />
              <Route
                path="/decisions"
                element={<AreaRoute area="decisions_access"><DecisionsRisks /></AreaRoute>}
              />
              <Route path="/links" element={<Links />} />
              <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
              <Route path="/admin/audit" element={<AdminRoute><AuditLog /></AdminRoute>} />
              <Route path="/admin/recycle-bin" element={<AdminRoute><RecycleBin /></AdminRoute>} />
              <Route path="/admin/settings" element={<AdminRoute><SystemSettings /></AdminRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </UserProvider>
    </div>
  );
}

export default App;
